import React from 'react'
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'

class ColorPicker extends React.Component {
    

    state = {
      showPicker: false,
      color: {
        r: '255',
        g: '255',
        b: '255',
        a: '100%',
      },
      
    };
 
    onClick = () => {
        this.setState({ 
          showPicker: !this.state.showPicker 
        })
    };
 
    onClose = () => {
      this.setState({ 
        showPicker: false 
      })
    };
 
    onChange = (color) => {
        this.setState({ 
          color: color.rgb 
        })
        localStorage.setItem('color', JSON.stringify(color));
    };
 
    render() {
      const styles = reactCSS({
        'default': {
          color: {
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
          },
          popover: {
            position: 'absolute',
            zIndex: '3',
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
          },
          swatch: {
            // padding: '6px',
            // background: '#ffffff',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'inline-block',
            // boxShadow: '0 0 0 1px rgba(0,0,0,.2)',
          },          
        },
      });
 
      return (
        <div>
          <div style={ styles.swatch } onClick={ this.onClick } className='swatch'>
            <div style={ styles.color } className='color' />
          </div>
          { this.state.showPicker ? <div style={ styles.popover } className='popover'>
            <div style={ styles.cover } onClick={ this.onClose }/>
            <SketchPicker color={ this.state.color } onChange={ this.onChange } />
          </div> : null }
        </div>
      )
    }
}
 
export default ColorPicker